import { DirectoryEmptyState } from './DirectoryEmptyState';
import { DirectorySearchError } from './DirectorySearchError';
import { DirectoryCardSkeletons } from './DirectorySkeletons';

type DirectoryListEmptyProps = {
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
  onResetSearch: () => void;
  numColumns?: number;
  /** Off for a list that can be empty with no filter to reset, which should show nothing. */
  showNoMatches?: boolean;
};

/**
 * What a directory list shows in place of its results when it has none. One component decides
 * between the placeholders, the failure and the no matches state, so every layout that draws
 * the directory answers an empty list the same way and a new state is added in one place.
 * Loading wins over failure, so a retry shows the placeholders until it settles.
 */
export function DirectoryListEmpty({
  isLoading,
  isError,
  onRetry,
  onResetSearch,
  numColumns,
  showNoMatches = true,
}: DirectoryListEmptyProps) {
  if (isLoading) {
    return <DirectoryCardSkeletons numColumns={numColumns} />;
  }

  if (isError) {
    return <DirectorySearchError onRetry={onRetry} />;
  }

  return showNoMatches ? <DirectoryEmptyState onResetSearch={onResetSearch} /> : null;
}
